// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Money_Rounded.eqMoney);
var PriceDiscountIsSymbol = {
    reflectSymbol: function () {
        return "PriceDiscount";
    }
};
var PercentageDiscountIsSymbol = {
    reflectSymbol: function () {
        return "PercentageDiscount";
    }
};
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var prizeIsSymbol = {
    reflectSymbol: function () {
        return "prize";
    }
};
var ExtraDiscountIsSymbol = {
    reflectSymbol: function () {
        return "ExtraDiscount";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var PriceDiscount = /* #__PURE__ */ (function () {
    function PriceDiscount(value0) {
        this.value0 = value0;
    };
    PriceDiscount.create = function (value0) {
        return new PriceDiscount(value0);
    };
    return PriceDiscount;
})();
var PercentageDiscount = /* #__PURE__ */ (function () {
    function PercentageDiscount(value0) {
        this.value0 = value0;
    };
    PercentageDiscount.create = function (value0) {
        return new PercentageDiscount(value0);
    };
    return PercentageDiscount;
})();
var ExtraDiscount = function (x) {
    return x;
};
var toFillFormTypeExtraDiscou = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeExtraDiscou1 = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeExtraDiscount_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldExtraDiscount = function (dictHasField) {
    return dictHasField;
};
var eqExtraDiscountPrize = {
    eq: function (x) {
        return function (y) {
            if (x instanceof PriceDiscount && y instanceof PriceDiscount) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof PercentageDiscount && y instanceof PercentageDiscount) {
                return x.value0 === y.value0;
            };
            return false;
        };
    }
};
var eq3 = /* #__PURE__ */ Data_Eq.eq(eqExtraDiscountPrize);
var eqExtraDiscount = {
    eq: function (x) {
        return function (y) {
            return x.name === y.name && eq3(x.prize)(y.prize);
        };
    }
};
var genericExtraDiscountPrize = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new PriceDiscount(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new PercentageDiscount(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Checkout.Types.ExtraDiscount (line 17, column 1 - line 17, column 91): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof PriceDiscount) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof PercentageDiscount) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Checkout.Types.ExtraDiscount (line 17, column 1 - line 17, column 91): " + [ x.constructor.name ]);
    }
};
var showExtraDiscountPrize = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericExtraDiscountPrize)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Money_Rounded.showMoney))(PriceDiscountIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))(PercentageDiscountIsSymbol)))
};
var unscrambleDecodeExtraDiscountPrize = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericExtraDiscountPrize)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(PriceDiscountIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Data_Money_Rounded.udecodeMoney)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(PercentageDiscountIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Unscramble.decodeInt1)))))(Unscramble_Generic.defaultOptions)
};
var genericExtraDiscount = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showExtraDiscount = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericExtraDiscount)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(nameIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(prizeIsSymbol)(showExtraDiscountPrize))(Data_Show.showString))))(ExtraDiscountIsSymbol))
};
var unscrambleDecodeExtraDiscount = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericExtraDiscount)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(nameIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(prizeIsSymbol)(unscrambleDecodeExtraDiscountPrize)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var encodeExtraDiscountPrize = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericExtraDiscountPrize)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PriceDiscountIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PercentageDiscountIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))))
};
var encodeExtraDiscount = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericExtraDiscount)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ExtraDiscountIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(prizeIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeExtraDiscountPrize)))(nameIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))
};
var decodeExtraDiscountPrize = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericExtraDiscountPrize)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PriceDiscountIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PercentageDiscountIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode)))(Foreign_Generic_Class.genericCountArgsArgument)))
};
var decodeExtraDiscount = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericExtraDiscount)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ExtraDiscountIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(prizeIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeExtraDiscountPrize))())(nameIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    PriceDiscount,
    PercentageDiscount,
    ExtraDiscount,
    genericExtraDiscountPrize,
    eqExtraDiscountPrize,
    showExtraDiscountPrize,
    encodeExtraDiscountPrize,
    decodeExtraDiscountPrize,
    unscrambleDecodeExtraDiscountPrize,
    toFillFormTypeExtraDiscou1,
    genericExtraDiscount,
    eqExtraDiscount,
    showExtraDiscount,
    encodeExtraDiscount,
    decodeExtraDiscount,
    unscrambleDecodeExtraDiscount,
    toFillFormTypeExtraDiscou,
    hasFieldExtraDiscount,
    newtypeExtraDiscount_
};
